import { baseThemeValues } from 'constants/common';

const boldBase = {
  fontFamily: baseThemeValues.inherit,
  fontWeight: 500,
  text: 'palette.tertiary.95',
};

const regularBase = {
  fontFamily: baseThemeValues.inherit,
  fontWeight: 400,
  text: 'palette.tertiary.95',
};

export const typographyTheme = {
  h1: {
    fontFamily: baseThemeValues.inherit,
    fontSize: '32px',
    fontWeight: 700,
    text: 'palette.tertiary.95',
  },
  h3: {
    fontFamily: baseThemeValues.inherit,
    fontSize: '24px',
    fontWeight: 700,
    text: 'palette.tertiary.95',
  },
  h4: {
    fontFamily: baseThemeValues.inherit,
    fontSize: '22px',
    fontWeight: 700,
    text: 'palette.tertiary.95',
  },
  h5: {
    fontFamily: baseThemeValues.inherit,
    fontSize: '18px',
    fontWeight: 700,
    text: 'palette.tertiary.95',
  },
  h6: {
    fontFamily: baseThemeValues.inherit,
    fontSize: '16px',
    fontWeight: 700,
    text: 'palette.tertiary.95',
  },
  p: {
    bold: {
      boldBase,
      lg: {
        ...boldBase,
        fontSize: '18px',
      },
      md: {
        ...boldBase,
        fontSize: '16px',
      },
      sm: {
        ...boldBase,
        fontSize: '14px',
      },
      xl: {
        ...boldBase,
        fontSize: '20px',
      },
      xs: {
        ...boldBase,
        fontSize: '12px',
      },
      xxl: {
        ...boldBase,
        fontSize: '22px',
      },
      xxs: {
        ...boldBase,
        fontSize: '12px',
      },
    },
    regular: {
      lg: {
        ...regularBase,
        fontSize: '18px',
      },
      md: {
        ...regularBase,
        fontSize: '16px',
      },
      regularBase,
      sm: {
        ...regularBase,
        fontSize: '14px',
      },
      xl: {
        ...regularBase,
        fontSize: '20px',
      },
      xs: {
        ...regularBase,
        fontSize: '12px',
      },
      xxl: {
        ...regularBase,
        fontSize: '22px',
      },
      xxs: {
        ...regularBase,
        fontSize: '10px',
      },
    },
  },
};
